






























import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import HistoryEvent from '@/dto/history/HistoryEvent'

@Component
export default class UserHistoryList extends Vue {
  @Prop(Array)
  historyEvents: HistoryEvent[]

  @Prop(Number)
  offset: number
}
